
  (function ($) {
    $(document).on( 'ready', function(){
      $('table span').each(function(){
        // console.log($(this).text());
        $(this).html().replace('/  /g','<br>');
      });
    });

    $(document).on('accordionChange', function(){
      $('table span').each(function(){
        // console.log($(this).text());
        $(this).html().replace('/  /g','<br>');
      });
    });
  })(jQuery);
